import React from 'react';
import PropTypes from 'prop-types';
import { size, get } from 'lodash';
import MenuItems from './MenuItems';
import MinifyMenuButton from './MinifyMenuButton';
import ToggleShortcut from '../layout/toggleShortcut';
import Image from '../Image/Image';
import { menuDataShape } from '../../shapes/layoutShape';
import { getClassNameGenerator } from '../../helper/className';
import classNames from 'classnames';

const Menu = ({ menuData, menuItems }) => (
  <aside
    id="left-panel"
    className={Menu.className}
  >
    <div className="login-info">
					<span>
						<ToggleShortcut>
								<i className="fa fa-lg fa-fw fa-reorder" />
						</ToggleShortcut>
					</span>
      <div
        className={classNames(
            menuData.logoClass,
            Menu.getClassName('logo-image-container', true)
          )}
      >
        <Image
          display-if={menuData.logoUrl}
          className={Menu.getClassName('logo-image', true)}
          src={menuData.logoUrl}
        />
      </div>
    </div>
    <MenuItems activeClass={Menu.getActiveClass(menuData)} items={menuItems} />
    <MinifyMenuButton />
  </aside>
);

Menu.className = 'esk-side-menu';
Menu.getClassName = getClassNameGenerator(Menu.className);

Menu.propTypes = {
  menuData: PropTypes.shape(menuDataShape),
  menuItems: PropTypes.array
};

Menu.defaultProps = {
  menuItems: [],
  menuData: {
    logoClass: 'default-info-img'
  }
};

Menu.getActiveClass = (menuData) => get(menuData, 'activeClass');

Menu.hasMenuItems = (items) => size(items) > 0;

export default Menu;
